import {defineMessages} from 'react-intl';

const messages = defineMessages({
	title: {
		id: 'cmsPreviewWidget.connection.title',
		defaultMessage: 'CMS connection',
	},
	overrideBadge: {
		id: 'cmsPreviewWidget.connection.overrideBadge',
		defaultMessage: 'Override',
	},
	hint: {
		id: 'cmsPreviewWidget.connection.hint',
		defaultMessage: 'For this browser session only. Empty fields keep the values of the instance.',
	},
	preset: {
		id: 'cmsPreviewWidget.connection.preset',
		defaultMessage: 'Preset',
	},
	presetDefault: {
		id: 'cmsPreviewWidget.connection.presetDefault',
		defaultMessage: 'Instance default',
	},
	presetCustom: {
		id: 'cmsPreviewWidget.connection.presetCustom',
		defaultMessage: 'Custom',
	},
	host: {
		id: 'cmsPreviewWidget.connection.host',
		defaultMessage: 'CPA host',
	},
	spaceId: {
		id: 'cmsPreviewWidget.connection.spaceId',
		defaultMessage: 'Space',
	},
	environmentId: {
		id: 'cmsPreviewWidget.connection.environmentId',
		defaultMessage: 'Environment',
	},
	token: {
		id: 'cmsPreviewWidget.connection.token',
		defaultMessage: 'API key',
	},
	tokenSet: {
		id: 'cmsPreviewWidget.connection.tokenSet',
		defaultMessage: 'Set (leave empty to keep it)',
	},
	tokenHint: {
		id: 'cmsPreviewWidget.connection.tokenHint',
		defaultMessage: 'Instance key (same host only)',
	},
	insecure: {
		id: 'cmsPreviewWidget.connection.insecure',
		defaultMessage: 'Plain http (local Content Hub)',
	},
	cmsUrl: {
		id: 'cmsPreviewWidget.connection.cmsUrl',
		defaultMessage: 'CMS url (Edit buttons)',
	},
	apply: {
		id: 'cmsPreviewWidget.connection.apply',
		defaultMessage: 'Connect',
	},
	reset: {
		id: 'cmsPreviewWidget.connection.reset',
		defaultMessage: 'Back to default',
	},
	error: {
		id: 'cmsPreviewWidget.connection.error',
		defaultMessage: 'Not accepted: {fields}',
	},
});

export default messages;
